var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-center"},[_c(_setup.CustomerRequiredDetailsForm,{staticClass:"max-w-720",on:{"update:customer":_setup.onCustomerUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }